import { render, staticRenderFns } from "./WalletParentChart.vue?vue&type=template&id=011243c3&scoped=true"
import script from "./WalletParentChart.vue?vue&type=script&lang=js"
export * from "./WalletParentChart.vue?vue&type=script&lang=js"
import style0 from "./WalletParentChart.vue?vue&type=style&index=0&id=011243c3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011243c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011243c3')) {
      api.createRecord('011243c3', component.options)
    } else {
      api.reload('011243c3', component.options)
    }
    module.hot.accept("./WalletParentChart.vue?vue&type=template&id=011243c3&scoped=true", function () {
      api.rerender('011243c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chartStatistical/WalletParentChart.vue"
export default component.exports